<template>
	<div class="container">

		<header class="container__header">

			<h1>Find produkt</h1>

		</header>


		<div class="container__body container__body--md">
			<transition name="fade" mode="out-in">
				<div class="wrap--xsm__left margin-b-75 search-picker" v-if="searchState === 'choose'" key="choose">

					<a class="btn--primary btn--sm primary--copper" @click.prevent="searchState = 'search'">Søg efter ordre</a>

					<p>eller</p>

					<a class="btn--primary btn--sm primary--copper" @click.prevent="searchState = 'product'">Vælg produkt</a>

				</div>

				<div class="wrap--xsm__left margin-b-75" v-else-if="searchState === 'search'" key="search">

					<div class="col-12 margin-b-25">

						<a class="" href="#" @click.prevent="searchState = 'choose'">Tilbage</a>

					</div>

					<form class="col-12" @submit.prevent="searchForOrders">

						<label>Hvilke ordre leder du efter?</label>

						<div class="search">

							<input class="col-12" type="text" name="name" autocomplete="off" placeholder="Find ordre" v-model="searchTerm">

							<button class="btn btn--md btn--primary primary--copper">

								<span>Søg</span>

							</button>

						</div>

						<div class="col-12 margin-t-25">

							<p class="tips">*Søg på ordrenr, navn, e-mail, tlf.</p>

						</div>

					</form>

				</div>

				<div v-else-if="searchState === 'product'" key="product">
					<div class="wrap--xsm__left border-b padding-b-25">

						<div class="col-12 margin-b-25">

							<a class="" href="#" @click.prevent="searchState = 'choose'">Tilbage</a>

						</div>

						<ws-select :options="productsForSelection" v-model="chosenProduct" emptytext="Vælg produkt" :use-null="true" @change="getOrdersForProduct"></ws-select>

					</div>

					<div class="wrap--xsm__left margin-t-50">

						<a class="btn--secondary btn--sm primary--grey" v-if="chosenProduct" @click.prevent="exportProductPdfs">Hent alle PDF'er</a>

						<a class="btn--secondary btn--md primary--grey" v-if="chosenProduct" @click.prevent="exportProductKitchenPdfs">Hent alle køkken PDF'er</a>

					</div>
				</div>
			</transition>

			<section class="search-result margin-t-75">

				<div class="filters margin-b-50 border-b padding-b-25">

					<h1>Resultat</h1>

					<nav>

						<ul>
							<li>Filtrer søgning: </li>
							<li><a href="#" :class="[currentFilter == 'all' ? 'active':'']" @click.prevent="changeFilter('all')">Alle ({{all.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'active' ? 'active':'']"  @click.prevent="changeFilter('active')">Åbne ({{active.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'delivered' ? 'active':'']" @click.prevent="changeFilter('delivered')">Udleveret ({{delivered.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'refunded' ? 'active':'']" @click.prevent="changeFilter('refunded')">Refunderet ({{refunded.length}})</a></li>
						</ul>

					</nav>

				</div>

				<transition-group name="fade" mode="out-in">

					<order v-for="(order, index) in currentResult" :order="order" @reload="reload" :key="`${order.id}-${index}`" v-if="!changingFilter"></order>

					<div class="no-result margin-t-25" v-if="currentResult.length === 0 && !changingFilter" key="notfound">

						<i class="icon--lg fas fa-sad-tear"></i>

						<h4>Ingen resultater fundet</h4>

					</div>

				</transition-group>

			</section>

		</div>

        <ws-modal v-model="showQueuedMessage">

            <section class="modal-wrap">

                <section class="modal--sm center">

                    <span class="close" @click.prevent="understood"><i class="fas fa-times"></i></span>

                    <transition name="fade" mode="out-in">

                        <section>
                            <h4>Vi er gået i gang med at skabe PDF'er for produktet.</h4>
                            <h4>Du vil, om et øjeblik, modtage en mail når de er klar</h4>
                            <h4 class="margin-t-25">I mellemtiden kan du fortsætte med at benytte systemet.</h4>

                            <a href="#" class="btn btn--primary btn--sm primary--copper margin-t-50" @click="understood">Fortsæt</a>
                        </section>

                    </transition>


                </section>

            </section>

        </ws-modal>

	</div>
</template>

<script>
	import Order from './components/order.vue';
    import {mapGetters} from 'vuex';
    export default {
        name:'order-search',
		components:{
          	Order
		},
        data(){
            return {
                searchTerm:'',
                all:[],
				active:[],
				delivered:[],
				refunded:[],
				currentFilter:'all',
				changingFilter:false,
				chosenProduct:null,
				searchState: 'choose',
                showQueuedMessage:false,
			};
		},
		computed:{
            ...mapGetters({
                products:'products'
            }),
			productsForSelection(){
                const productsList = {};
              	this.products.forEach(item =>{
              	    productsList[item.id] = item.title;
				});
				return productsList;
			},
			currentResult(){
				switch (this.currentFilter) {
					case 'active':
					    return this.active;
					case 'delivered':
					    return this.delivered;
					case 'refunded':
					    return this.refunded;
					case 'all':
					default:
					    return this.all;
                }
			},
            downloadURL(){
                //return `/admin/product/${this.chosenProduct}/orders/pdf`;
            },
            downloadKitchenURL(){
                //return `/admin/product/${this.chosenProduct}/orders/kitchen/pdf`;
            }
		},
		methods:{
			getAllOrders(){
			    this.chosenProduct = null;
                this.currentFilter = 'all';

			    axios.post(`/api/admin/order/search`, {search:''}).then(response=>{

                    const all = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                    const active = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                    const delivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                    const refunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);

                    axios.post(`/api/admin/productless/order/search`, {search:''}).then(response=>{


                        const productlessAll = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                        const productlessActive = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                        const productlessDelivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                        const productlessRefunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);

                        this.all = _.concat(all, productlessAll);
                        this.active = _.concat(active, productlessActive);
                        this.delivered = _.concat(delivered, productlessDelivered);
                        this.refunded = _.concat(refunded, productlessRefunded);

                    });

                });
			},
			searchForOrders(){
                this.chosenProduct = null;
                this.currentFilter = 'all';
                axios.post(`/api/admin/order/search`, {search:this.searchTerm}).then(response=>{
                    console.log(response.data.data);

                    const all = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                    const active = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                    const delivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                    const refunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);

                        axios.post(`/api/admin/productless/order/search`, {search:this.searchTerm}).then(response=>{
                            this.searchTerm = '';
                            const productlessAll = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                            const productlessActive = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                            const productlessDelivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                            const productlessRefunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);

                            this.all = _.concat(all, productlessAll);
                            this.active = _.concat(active, productlessActive);
                            this.delivered = _.concat(delivered, productlessDelivered);
                            this.refunded = _.concat(refunded, productlessRefunded);
                        });
                });
			},
			getOrdersForProduct(){
                this.currentFilter = 'all';
                axios.get(`/api/admin/product/${this.chosenProduct}/orders`, {search:this.searchTerm}).then(response=>{
                    this.all = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                    this.active = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                    this.delivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                    this.refunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);
                });
			},
			reload(){
				if(this.searchTerm){
					return this.searchForOrders();
				}

				this.getAllOrders();
			},
			changeFilter(type){
			    this.changingFilter = true;
				this.currentFilter = type;
			    setTimeout(()=>{
					this.changingFilter = false;
				}, 500);
			},
            exportProductPdfs(){
                this.showQueuedMessage = true;
                axios.post(`/api/admin/product/${this.chosenProduct}/orders/pdf`, {}).then(response => {});
            },
            exportProductKitchenPdfs(){
                this.showQueuedMessage = true;
                axios.post(`/api/admin/product/${this.chosenProduct}/orders/kitchen/pdf`, {}).then(response => {});
            },
            understood(){
                setTimeout(()=>{
                    this.showQueuedMessage = false
                }, 200);
            },
		},
		created(){
            this.$store.dispatch('getProducts');
            if(this.$route.params.order){
                this.searchTerm = this.$route.params.order
				return this.searchForOrders();
			}

			this.getAllOrders();
		}
    }
</script>
